//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** System Categories */
export const Category = {
    /** Communication Segments Dataview Category Guid */
    DataviewCommunicationSegments: "FF7081F8-7223-43D4-BE28-CB030DC4E13B",
    /** Campus Category */
    DefinedtypeCampus: "4503C83E-4171-4EAE-99C1-A3647E065181",
    /** CMS Category */
    DefinedtypeCms: "6B1B3106-B7F5-BBA2-4F81-8300F21F6661",
    /** CMS Settings Category */
    DefinedtypeCmsSettings: "262313F6-5D66-41CE-9B6F-D36567D9AB9D",
    /** The 'Public' category for Communication List groups */
    GrouptypeCommunicationlistPublic: "A0889E77-67D9-418C-B301-1B3924692058",
    /** The history attendance changes for a person */
    HistoryAttendanceChanges: "BF6ABCD3-AD41-4D54-998F-B83C302756E3",
    /** History of connection request changes */
    HistoryConnectionRequest: "A8542DD2-91B1-4CCA-873A-D052BCD6EE06",
    /** History changes for an event registration */
    HistoryEventRegistration: "813DF1A5-ADBD-481C-AC1D-884F0FA7AE77",
    /** History of changes to batches */
    HistoryFinancialBatch: "AF6A8CFF-F24F-4AA8-B126-94B6903961C0",
    /** History of changes to transaction and/or transaction details */
    HistoryFinancialTransaction: "477EE3BE-C68F-48BD-B218-FAFC99AF56B3",
    /** Parent group for Group History */
    HistoryGroup: "180C5767-8769-4C51-865F-FEE29AEF80A0",
    /** History of group changes */
    HistoryGroupChanges: "089EB47D-D0EF-493E-B867-DC51BCDEF319",
    /** History changes for person */
    HistoryPerson: "6F09163D-7DDD-4E1E-8D18-D7CAA04451A7",
    /** History of person activity */
    HistoryPersonActivity: "0836845E-5ED8-4ABE-8787-3B61EF2F0FA5",
    /** The history person analytics */
    HistoryPersonAnalytics: "C1524D2E-3E8F-3D83-45F8-526B749D79F0",
    /** History of person communications */
    HistoryPersonCommunications: "F291034B-7581-48F3-B522-E31B8534D529",
    /** History of connection request */
    HistoryPersonConnectionRequest: "4B472C6A-1ACF-481E-A2D4-9C44436BBCF5",
    /** History of person demographic changes */
    HistoryPersonDemographicChanges: "51D3EC5A-D079-45ED-909E-B0AB2FD06835",
    /** History of Family changes */
    HistoryPersonFamilyChanges: "5C4CCE5A-D7D0-492F-A241-96E13A3F7DF8",
    /** history of group membership */
    HistoryPersonGroupMembership: "325278A4-FACA-4F38-A405-9C090B3BAA34",
    /** History of person registering or being registered */
    HistoryPersonRegistration: "DA9C0CC7-7B31-4E1E-BBA5-50405B2D9EFE",
    /** History of step */
    HistoryPersonStep: "517BB2D3-0A50-4132-818E-63BB3C81EAE9",
    /** The insights metrics Category Guid */
    Insights: "CEC746EE-76D6-477F-B7CF-374542F92041",
    /** Hosting Metrics Metric Category Guid */
    MetricHostingMetrics: "370FBBD8-7766-4B3F-81A9-F13EE819A832",
    /** The category for the Check-in Manager Roster Alert Icons */
    PersonAttributesCheckInRosterAlertIcon: "367571D1-62D3-4948-B588-C0FDCE00CF27",
    /** The category for person attributes for DISC */
    PersonAttributesDisc: "0B187C81-2106-4875-82B6-FBF1277AE23B",
    /** The category for person attribute for ERA */
    PersonAttributesEra: "266A1EA8-425C-7BB0-4191-C2E234D60086",
    /** The category for person attribute for Finance Internal */
    PersonAttributesFinanceInternal: "3030B3E2-91EE-4833-BACE-47F775FA98A0",
    /** Obsolete. Use Rock.SystemGuid.Category.PERSON_ATTRIBUTES_GIVING_OVERVIEW instead */
    PersonAttributesGivingAnalytics: "61823196-8EA1-4C2B-A7DF-1654BD085667",
    /** Person Attribute Category for Giving Overview */
    PersonAttributesGivingOverview: "61823196-8EA1-4C2B-A7DF-1654BD085667",
    /** The category for person attributes for Personality Assessment Data */
    PersonAttributesPersonalityAssessmentData: "B08A3096-FCFA-4DA0-B95D-1F3F11CC9969",
    /** The category for person attributes Social guid */
    PersonAttributesSocial: "DD8F467D-B83C-444F-B04C-C681167046A1",
    /** The Personal Merge Template Category guid */
    PersonalMergeTemplate: "A9F2F544-660B-4176-ACAD-88898416A66E",
    /** The category for defined types for PowerBI */
    PowerbiDefinedType: "FF0B8B72-C1A3-BB99-4D51-78BC670ADB9C",
    /** The registration attribute category that indicates Registration Attributes that should be prompted for at the end of the registration process. */
    RegistrationAttributeEndOfRegistration: "4648196E-CEB8-4D76-8F27-273EBBC35A08",
    /** The registration attribute category that indicates Registration Attributes that should be prompted for at the start of the registration process. */
    RegistrationAttributeStartOfRegistration: "27808664-97E7-432B-A1E7-D02F6DE5977A",
    /** Gets the Metrics schedule category guid */
    ScheduleMetrics: "5A794741-5444-43F0-90D7-48E47276D426",
    /** Gets the DataView Persisted Schedule category guid */
    SchedulePersistedDataviews: "EEC7A935-BEF2-4450-9CBF-B85CEC6F7FEA",
    /** Gets the Service Times schedule category guid */
    ScheduleServiceTimes: "4FECC91B-83F9-4269-AE03-A006F401C47E",
    /** The System Communication RSVP Confirmation Category guid */
    SystemCommunicationRsvpConfirmation: "19024818-E456-4642-8858-F50C8B6DB5ED",
    /** The system communication Sign-Up Group confirmation Category guid */
    SystemCommunicationSignupGroupConfirmation: "CB279EE1-9A12-4837-9A14-1F36B6F7CDAF",
    /** The System Communication Workflow Category guid */
    SystemCommunicationWorkflow: "D8EC958D-ADD5-48FC-B539-CB919F5C9D32",
    /** The System Email Workflow Category guid */
    SystemEmailWorkflow: "C7B9B5F1-9D90-485F-93E4-5D7D81EC2B12",
    /** The GUID for the WorkflowType category "Check-in" */
    WorkflowTypeCheckin: "8F8B272D-D351-485E-86D6-3EE5B7C84D99",
    /** The GUID for the WorkflowType category "Data Integrity" */
    WorkflowTypeDataIntegrity: "BBAE05FD-8192-4616-A71E-903A927E0D90",
    /** The GUID for the WorkflowType category "Requests" */
    WorkflowTypeRequests: "78E38655-D951-41DB-A0FF-D6474775CFA1",
    /** The GUID for the WorkflowType category "Safety &amp; Security" */
    WorkflowTypeSafetyAndSecurity: "6F8A431C-BEBD-4D33-AAD6-1D70870329C2",
    /** The GUID for the WorkflowType "Category Samples" */
    WorkflowTypeSamples: "CB99421E-9ADC-488E-8C71-94BB14F27F56",
    /** The GUID for the WorkflowType category "Staff Forms" */
    WorkflowTypeStaffForms: "25E6844F-59BA-4C0D-9284-ED2A558E18EC",
};
